// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const APPROVAL_BASE_URL = '/api/v1/wechat/approval';

/**
 * 获取审批模板列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getApprovalTemplateList(
  params?: OA.ApprovalTemplateListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ApprovalTemplate[]>>(`${APPROVAL_BASE_URL}/templates`, {
    method: 'GET',
    params: params || {},
    ...(options || {}),
  });
}

/**
 * 创建审批模板记录（仅管理员）
 * @param data 创建参数
 * @param options 请求配置
 */
export async function createApprovalTemplate(
  data: OA.CreateApprovalTemplateParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<{ id: number }>>(`${APPROVAL_BASE_URL}/templates`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 更新审批模板记录（仅管理员）
 * @param templateId 模板ID
 * @param data 更新参数
 * @param options 请求配置
 */
export async function updateApprovalTemplate(
  templateId: string,
  data: OA.UpdateApprovalTemplateParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.MessageResponse>>(
    `${APPROVAL_BASE_URL}/templates/${templateId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
      ...(options || {}),
    },
  );
}

/**
 * 获取审批模板详情（从企业微信）
 * @param data 请求参数
 * @param options 请求配置
 */
export async function getApprovalTemplateDetail(
  data: OA.GetApprovalTemplateDetailParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ApprovalTemplateDetail>>(
    `${APPROVAL_BASE_URL}/template-detail`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
      ...(options || {}),
    },
  );
}

/**
 * 提交审批申请
 * @param data 审批申请参数
 * @param options 请求配置
 */
export async function submitApproval(
  data: OA.SubmitApprovalParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.SubmitApprovalResult>>(`${APPROVAL_BASE_URL}/apply`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取审批申请详情
 * @param data 请求参数
 * @param options 请求配置
 */
export async function getApprovalDetail(
  data: OA.GetApprovalDetailParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ApprovalDetail>>(`${APPROVAL_BASE_URL}/detail`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取审批申请列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getApprovalApplicationList(
  params: OA.ApprovalApplicationListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ApprovalApplicationListData>>(
    `${APPROVAL_BASE_URL}/applications`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/**
 * 获取部门审批申请列表（部门负责人专用）
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getDepartmentApprovalApplicationList(
  params: OA.ApprovalApplicationListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ApprovalApplicationListData>>(
    `${APPROVAL_BASE_URL}/applications/department`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/**
 * 获取我的审批申请列表（个人发起的审批）
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getMyApprovalApplicationList(
  params: OA.ApprovalApplicationListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ApprovalApplicationListData>>(
    `${APPROVAL_BASE_URL}/applications/my`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/**
 * 作废审批流程
 * @param data 作废参数
 * @param options 请求配置
 */
export async function revokeApproval(
  data: OA.RevokeApprovalParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.RevokeApprovalResult>>(`${APPROVAL_BASE_URL}/revoke`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 为角色分配审批模板权限
 * @param data 分配参数
 * @param options 请求配置
 */
export async function assignApprovalPermission(
  data: OA.AssignApprovalPermissionParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${APPROVAL_BASE_URL}/permissions/assign`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 撤销角色的审批模板权限
 * @param data 撤销参数
 * @param options 请求配置
 */
export async function revokeApprovalPermission(
  data: OA.RevokeApprovalPermissionParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${APPROVAL_BASE_URL}/permissions/revoke`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取角色的审批模板权限列表
 * @param roleId 角色ID
 * @param options 请求配置
 */
export async function getRoleApprovalPermissions(
  roleId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ApprovalPermission[]>>(
    `${APPROVAL_BASE_URL}/permissions/role/${roleId}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 部门印鉴审批列表项
 */
export interface DepartmentSealApproval {
  sp_no: string;
  template_id: string;
  template_name: string;
  applicant_userid: string;
  applicant_name: string;
  apply_time: string;
  sp_status: number;
  sp_status_text: string;
  seal_content: string;
  seal_type: string;
}

/**
 * 部门印鉴审批列表参数
 */
export interface DepartmentSealApprovalParams {
  page?: number;
  page_size?: number;
  starttime?: number;
  endtime?: number;
}

/**
 * 获取部门印鉴管理审批列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getDepartmentSealApprovals(
  params?: DepartmentSealApprovalParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<{ items: DepartmentSealApproval[]; total: number; page: number; page_size: number }>>(
    `${APPROVAL_BASE_URL}/applications/department-seal`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/**
 * 签名媒体文件
 */
export interface SignatureMediaFile {
  media_id: string;
  file_url: string;
  filename: string;
  file_size: number;
}

/**
 * 获取流程签名媒体资源并上传
 * @param spNo 审批单号
 * @param options 请求配置
 */
export async function getProcessSignatureMedia(
  spNo: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<{ sp_no: string; uploaded_files: SignatureMediaFile[]; errors: any[] | null }>>(
    `${APPROVAL_BASE_URL}/process-signature-media/${spNo}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 导出印鉴使用办文单
 * @param spNo 审批单号
 * @param options 请求配置
 */
export async function exportSealUseForm(
  spNo: string,
  options?: { [key: string]: any },
) {
  return request<Blob>(`${APPROVAL_BASE_URL}/export-seal-use-form/${spNo}`, {
    method: 'GET',
    responseType: 'blob',
    ...(options || {}),
  });
}

